export default "__VITE_ASSET__Ckx1dIE$__"